import React from "react";

const withLazyLoad = (importFunc: () => Promise<{ default: React.ComponentType<any> }>) => {
  const LazyComponent = React.lazy(importFunc);

  return (props: Record<string, any>) => (
    <React.Suspense
      fallback={
        <h1>Loading...</h1>
      }
    >
      <LazyComponent {...props} />
    </React.Suspense>
  );
};

export default withLazyLoad;
